import React from 'react';
import * as Sentry from '@sentry/react';
import { enableMapSet } from 'immer';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import './index.css';

// Enable immer support for Map & Set
enableMapSet();

Sentry.init({
  dsn: 'https://4055be43838343a0a1d217ef5147a210@o4509195528437760.ingest.de.sentry.io/4509201947295824',
  integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  // @ts-ignore
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <CssBaseline />
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
